module.exports = __webpack_public_path__ + "media/images/shark/Naranjo_9201-ff04d4c3349c990c39f6563f98177cfa.jpg";